class McBase extends HTMLElement {
    constructor(){
        super();
        this.internals = this.attachInternals();
    }
    open = () => {
        try{
            this.internals.states.add('open');
        }
        catch{
            this.internals.states.add('--open');
        }
        finally{
            this.postOpen();
        }
    }
    close = () => {
        this.internals.states.delete('open');
        this.internals.states.delete('--open');
        this.postClose();
    }

    postOpen = () => {}
    postClose = () => {}

    
}

window.McBase = McBase;